import React, {useState} from "react";
import {Button, Form, Input} from "antd";

const formItemLayout = {
  labelCol: {span: 4},
  wrapperCol: {span: 18},
}

const Audit = ({form, data, submit, ...props}) => {
  const {getFieldDecorator, validateFields, setFields} = form

  const _submit = (pass) => {
    validateFields((err, values) => {
      if (!err) {
        if ([null, undefined].indexOf(pass) !== -1) {
          wizNotice.error('请确认审核状态');
          return;
        } else if(pass === 3 && !values?.comment) {
          setFields({comment: {errors: [{message: "审核未通过时意见不能为空"}]}})
          return;
        }

        submit && submit({...values, state: pass});
      }
    });

  }

  return (
    <Form {...formItemLayout}>
      {getFieldDecorator('ids', {initialValue: data?.map(item => item?.id)})}
      <Form.Item label="审核意见">
        {
          getFieldDecorator('comment', {
            initialValue: '',
          })(<Input.TextArea placeholder='请输入审核意见' maxLength={200} autoSize={{minRows: 3, maxRows: 6}}/>)
        }
      </Form.Item>
      <Form.Item wrapperCol={{span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span}}>
        <Button onClick={() => _submit(2)}>通过</Button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Button onClick={() => _submit(3)}>不通过</Button>
      </Form.Item>
    </Form>
  )
}

let AuditForm = Form.create()(Audit)
export {
  AuditForm,
}

